<template>
  <div class="box">
    <div class="max">
      <div class="btn">
        <el-button type="" style="background: #aaf" size="mini" :loading="loading" @click="hujiaoOk">呼叫班组长</el-button>
        <el-button type="" style="background: #3f8cf9" size="mini" :loading="loading" @click="callHelp">呼叫帮教工</el-button>
        <el-button type="" style="background: #f9888d" size="mini" :loading="loading" @click="callJoint">呼叫接头工</el-button>
        <el-button type="" style="background: #aaf" size="mini" @click="handleFnderClick">织造对样</el-button>
        <el-button type="" style="background: #f3b154" size="mini" @click="torenwushu">任务书查看</el-button>
        <el-button type="" style="background: #3f8cf9" size="mini" @click="tofiberOk">报工</el-button>
        <el-button type="" style="background: #f9888d" size="mini" @click="toDyfiberOk">打样报工</el-button>
        <el-button type="" style="background: #27d3a5" siz e="mini" @click="toBaobiao">生产报表</el-button>
        <el-button type="" style="background: #aaf" size="mini" @click="ISZZWorkEND">任务结束</el-button>
        <el-button type="" style="background: #faa" size="mini" @click="JTWorkEND">接头报工</el-button>
        <!-- <el-button
          type=""
          disabled
          style="background: #27d3a5"
          size="mini"
          @click="callAGV"
          >AGV调度</el-button
        >
        <el-button type="primary" disabled size="mini" @click="isAGVCode = true"
          >落布完成</el-button
        > -->
      </div>
      <div class="bottom">
        <div class="left">
          <div class="top">
            <div class="saoma">
              <p>任务书号：</p>
              <el-input v-model="store.cardNumber" placeholder="请输入任务书号" clearable size="small" ref="saveTagInput"
                @focus="open" @change="confirmFn1">
                <template slot="append">
                  <img slot="append" src="@/assets/img/sm.png" alt="" @click="getSaoma" style="background: #faa" />
                </template>
              </el-input>
            </div>
          </div>
          <div class="bottom">
            <!-- <h1 class="title">任务列表:</h1> -->
            <div class="list list1" v-for="(item, index) of list" :key="index" :class="{ active: currentIndex === index }"
              @click="selectItem(item, index)">
              <div class="text text1">
                <p>
                  <span>单据编号:</span>
                  <span>
                    {{ item.BILLNO }}
                  </span>
                </p>
                <p>
                  <span>任务书号:</span>
                  <span>
                    {{ item.WEAVNO }}
                  </span>
                </p>
                <p>
                  <span>经轴卡号:</span>
                  <span>
                    {{ item.WARPPLANNO }}
                  </span>
                </p>
                <p>
                  <span>产品型号:</span>
                  <span>
                    {{ item.PRODUCTID }}
                  </span>
                </p>
              </div>
              <div class="btns">
                <el-button v-show="item.STATEID === 0" size="mini" style="background: #3f8cf9">未领料</el-button>
                <el-button v-show="item.STATEID === 1" size="mini" style="background: #f9888d">已领料待生产</el-button>
                <el-button v-show="item.STATEID === 2" size="mini" style="background: #f3b154">生产中</el-button>
                <el-button v-show="item.STATEID === 3" size="mini" style="background: #27d3a5">生产已完工</el-button>
                <el-button v-show="item.STATEID === 4" size="mini" style="background: #aaf">半成品验布中</el-button>
                <el-button v-show="item.STATEID === 5" size="mini" style="background: #faa">半成品验布已完工</el-button>
                <el-button v-show="item.STATEID === 6" size="mini" style="background: #af8cf9">成品验布中</el-button>
                <el-button v-show="item.STATEID === 7" size="mini" style="background: #a9888d">成品验布完工</el-button>
                <el-button v-show="item.STATEID === 8" size="mini" style="background: #a3b154">委外未发料</el-button>
                <el-button v-show="item.STATEID === 9" size="mini" style="background: #a7d3a5">对样成功</el-button>
                <el-button v-show="item.STATEID === 10" size="mini" style="background: #aaf">对样失败</el-button>
                <el-button v-show="item.STATEID === 11" size="mini" style="background: #faa">织造暂停</el-button>
              </div>
            </div>
            <div class="empty" v-show="list.length <= 0">
              <van-empty description="暂无数据" />
            </div>
          </div>
          <h1 class="title">对样记录</h1>
          <div class="content">
            <!-- <div
              class="list"
              v-for="(item, index) of cheackList"
              :key="index"
              :class="{ active: currentIndex1 === index }"
              @click="selectItem1(item, index)"
            > -->
            <div class="list" :data="cheackList">
              <div class="text">
                <p style="width: 49%">
                  <span>对样人名称:</span>
                  <span>
                    {{ cheackList.WorkersName }}
                  </span>
                </p>
                <p style="width: 49%">
                  <span>对样缸号:</span>
                  <span>
                    {{ cheackList.SUBBATCHNO }}
                  </span>
                </p>
                <p>
                  <span>对样结果:</span>
                  <span :style="{
                    color: [
                      cheackList.CHECKRESULT == '不合格' ? '#f00' : '#323232',
                    ],
                  }">
                    {{ cheackList.CHECKRESULT }}
                  </span>
                </p>

                <p>
                  <span>对样时间:</span>
                  <span>
                    {{ cheackList.CREATETIME }}
                  </span>
                </p>
                <p>
                  <span>失败原因:</span>
                  <span>
                    {{ cheackList.ErrorResult }}
                  </span>
                </p>
              </div>

              <el-button type="danger" size="mini" @click="more">查看所有</el-button>
            </div>
          </div>
          <div class="img">
            <img class="bigimg" :src="operation.IMGSRC" alt="" />
          </div>
        </div>
        <div class="right">
          <div class="top">
            <!-- <h1 class="title">任务详情:</h1> -->
            <el-row class="row">
              <el-row class="row">
                <el-col :span="8">任务书号：{{ operation.WEAVNO }}</el-col>
                <el-col :span="8">织造计划号：{{ operation.WEAVPLANNO }}</el-col>
                <el-col :span="8">经轴卡号：{{ operation.WARPPLANNO }}</el-col>
                <el-col :span="8">任务书缸号：{{ operation.SUBBATCHNO }}</el-col>
                <el-col :span="8">单据日期：{{ operation.BILLDATE }}</el-col>
                <el-col :span="8">订单号：{{ operation.ORDERID }}</el-col>
                <el-col :span="8">经轴类型：{{ operation.BEAMTYPEID }}</el-col>
                <el-col :span="8">产品型号：{{ operation.PRODUCTID }}</el-col>
                <el-col :span="8">织造完成数量：{{ operation.FINISHQUANTITY }}</el-col>
                <el-col :span="8">未开米数:{{ operation.UnFINISHQUANTITY }}</el-col>
                <el-col :span="8">完成卷数：{{ operation.COMPLETEROLLNUM }}</el-col>
                <el-col :span="8">未完成卷数:{{ operation.UnCOMPLETEROLLNUM }}</el-col>
                <el-col :span="8">织造机台：{{ operation.WEAVDEVICEID }}</el-col>
                <el-col :span="8">决议交期：{{ operation.FINALDELIVERYTIME }}</el-col>
                <el-col :span="8">落布米数:{{ operation.HorseLength }}</el-col>
              </el-row>
            </el-row>
          </div>
          <div class="bottom">
            <!-- <h1 class="title">任务明细区（报工明细）:</h1> -->
            <div class="tab">
              <el-table :data="tableData" height="400" size="mini" stripe style="width: 100%" border ref="multipleTable"
                :row-class-name="getTabIndex">
                <el-table-column type="index" width="35" label="序号"></el-table-column>
                <el-table-column prop="WEAVNO" label="任务书号"></el-table-column>
                <el-table-column prop="SERIALNO" label="流水号">
                </el-table-column>
                <el-table-column prop="SUBBATCHNO" label="缸号">
                </el-table-column>
                <el-table-column prop="EQUIPMENTID" label="机台号">
                </el-table-column>
                <el-table-column prop="MachineNumber" label="数采米数">
                </el-table-column>
                <el-table-column prop="MachineWeft" label="数采纬数">
                </el-table-column>
                <el-table-column prop="InputNumber" label="报工米数">
                  <template slot-scope="scope">
                    <div class="InputNumber">
                      <span v-if="!scope.row.isEdit">{{
                        scope.row.InputNumber
                      }}</span>
                      <el-input v-else v-model="scope.row.InputNumber" placeholder="请输入报工米数" size="mini" clearable />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="WorkersName" label="报工人">
                </el-table-column>
                <el-table-column prop="BILLDATE" label="报工时间" width="130">
                </el-table-column>
                <!-- <el-table-column label="操作" width="40">
                  <template slot-scope="scope">
                    <el-button v-if="!scope.row.isEdit" type="text" size="mini" @click="handleEdit(scope.row)">编辑
                    </el-button>
                    <el-button v-else type="text" size="mini" @click="handleEditOk(scope.$index, scope.row)">确定
                    </el-button>
                  </template>
                </el-table-column> -->
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 扫码 -->
    <el-dialog title="落布完成" width="40%" center v-model="isAGVCode" :visible.sync="isAGVCode" :before-close="handleClose">
      <div class="code-input">
        <span>扫码：</span>
        <el-input v-model="store.AGVCode" size="mini">
          <template slot="append">
            <el-button type="primary" @click="getAGVCode" size="mini">
              扫码
            </el-button>
          </template>
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="isAGVCode = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="AGVCodeBlur" size="mini">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 对样 -->
    <el-dialog title="对样" width="60%" center :visible.sync="isSample" :show-close="false" :before-close="handleClose">
      <sample-code :operation="operationModel"></sample-code>
      <!-- fotter -->
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="isSample = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="SampleCodeBlur" :loading="loading" size="mini">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 查看所有 -->
    <el-dialog title="查看所有" width="70%" center :visible.sync="ischeack" :show-close="false" :before-close="handleClose">
      <div class="list" v-for="(item, index) of cheackLists" :key="index">
        <div class="text">
          <p style="width: 75%">
            <span>对样人名称:</span>
            <span>
              {{ item.WorkersName }}
            </span>
          </p>
          <p>
            <span>对样缸号:</span>
            <span>
              {{ item.SUBBATCHNO }}
            </span>
          </p>
          <p>
            <span>对样结果:</span>
            <span :style="{
              color: [item.CHECKRESULT == '不合格' ? '#f00' : '#323232'],
            }">
              {{ item.CHECKRESULT }}
            </span>
          </p>

          <p style="width: 100%">
            <span>对样时间:</span>
            <span>
              {{ item.CREATETIME }}
            </span>
          </p>
          <p>
            <span>失败原因:</span>
            <span>
              {{ item.ErrorResult }}
            </span>
          </p>
        </div>
      </div>
      <!-- <el-table border :data="cheackLists" stripe="" size="mini" width="100%">
        <el-table-column prop="WorkersName" label="对样人名称">
        </el-table-column>
        <el-table-column prop="SUBBATCHNO" label="对样缸号"></el-table-column>
        <el-table-column prop="CHECKRESULT" label="对样结果"></el-table-column>
        <el-table-column prop="ErrorResult" label="失败原因"> </el-table-column>
        <el-table-column prop="CREATETIME" label="对样时间"> </el-table-column>
      </el-table> -->
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="ischeack = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="ischeack = false" :loading="loading" size="mini">确 定</el-button>
      </span>
    </el-dialog>
    <!-- <van-popup
      v-model="orCodeValStatic"
      position="right"
      :overlay="locationLayer"
      :class="locationLayer ? 'orBgcPop' : ''"
    >
      <orCdeSingle
        :orType="orCodeType"
        :orCodeStatic="orCodeStaticVal"
        @multipleOR="multipleOR"
        @endOrcodeWindow="endOrcodeWindow"
        @layerEnd="layerEnd"
      ></orCdeSingle>
    </van-popup> -->
    <!-- 验证任务书设备 -->
    <el-dialog title="" :visible.sync="dialogVisible2" width="30%" center>
      <span style="color: #f00; line-height: 0.8rem; font-size: 0.3rem">{{
        mes3
      }}</span>
      <span slot="footer" class="dialog-footer btn2">
        <el-button type="primary" size="mini" @click="sure" :loading="loading">确 定</el-button>
        <el-button @click="goOut" type="danger" size="mini">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 扫码功能 -->
    <div class="code-reader-content" v-if="showvideo">
      <div class="page">
        <video ref="video" autoplay id="video"></video>
        <p v-if="videoInputDevicesArray.length == 0">{{ textContent }}</p>
      </div>
      <div class="scan-box">
        <div class="frame upper-left"></div>
        <div class="frame upper-right"></div>
        <div class="frame lower-right"></div>
        <div class="frame lower-left"></div>
        <div class="pointer-box">
          <div class="pointer"></div>
        </div>
        <div v-show="tipShow" class="tip">{{ tipMsg }}</div>
        <div class="btn-switch" @click="toggle">
          <span class="right" @click="colose()">关闭</span>
        </div>
      </div>
    </div>
    <!-- 判断匹长 -->
    <el-dialog title="" :visible.sync="dialogVisible1" width="30%" center>
      <span style="color: #f00; line-height: 0.8rem; font-size: 0.3rem">{{
        mes1
      }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="conmitOk" :loading="loading">确 定</el-button>
        <el-button @click="cancel" type="danger" size="mini">取 消</el-button>
      </span>
    </el-dialog>
    <Clavier v-if="show" :show="show" @updatekey="GetKeyVal"></Clavier>
  </div>
</template>
<script>
import SampleCode from "./SampleCode.vue";
// 引入插件
import { BrowserMultiFormatReader } from "@zxing/library";
import { api } from "../../api/index";
import localStorage from "../../api/localStorage";
import { Notify } from "vant";
import orCdeSingle from "../../components/orCode/orCodePD";
import storage from "../../api/storage";
import Clavier from "../../components/Clavier.vue";
export default {
  name: "ZhiZao",
  components: {
    SampleCode,
    orCdeSingle,
    Clavier,
  },
  data() {
    return {
      show: false,
      // 关于扫码
      dialogVisible1: false,
      ischeack: false,
      dialogVisible2: false,
      cheackList: [],
      mes1: "",

      showvideo: false,
      codeReader: null,
      tipMsg: "正在尝试识别....",
      tipShow: true,
      textContent: undefined,
      videoInputDevicesArray: [],

      deviceId: "",
      isEswitch: false,
      timer: null,
      SUBBATCHNO: "",
      WorkersName: "",
      WeavNo: "",
      PRODUCTID: "",
      ErrorResult: "",
      isSample: false,
      isAGVCode: false,
      dialogVisible: false,
      qita: "",
      // 带有流水号禁用上面按钮
      isD: false,
      currentIndex: null,
      currentIndex1: null,
      dian: true,
      qj: false,
      zz: false,
      cheackLists: [],
      setTimer: null,
      timer: null,
      // path: "ws://192.168.1.34:9988",
      socket: "",
      highlight: true,
      hujiao: false,
      end: false,
      baogong: false,
      list: [],
      // 对样不合格记录
      cheackList: [],
      CHECKRESULT: "",
      CREATETIME: "",
      // 单选框对应当前行数据
      operation: {},
      operationModel: {},
      shebei: "",
      jingzhouka: "",
      tableData: [],
      store: {
        sbInput: "",
        cardNumber: "",
      },
      Total: {
        pageNum: 1,
        pageSize: 1,
      },
      // cardNumber: "20221120001",
      // 分页
      listPage: {
        Page: 1,
        PageSize: 10000,
      },
      user: localStorage.getUser(),
      loading: false,
      wUsers: storage.getWorkersUsers(),
      mes3: "",
    };
  },
  created() {
    this.confirmFn();
    // this.openScan();
    //  this.WorkersUsersID = storage.getWorkersUsers().WID;
    // this.WorkersName = storage.getWorkersUsers().WName;
    // console.log(this.WorkersName, this.WorkersUsersID);
  },

  destroyed() {
    // this.codeReader.stopContinuousDecode();
    // this.codeReader.reset();
  },
  mounted() {
    // this.confirmFn()
  },
  watch: {
    $route: {
      handler() {
        this.user = storage.getUser();
      },
      // 深度观察监听
      deep: true,
      immediate: true,
    },
  },
  activated() {
    this.$refs.saveTagInput.focus();
    console.log(this.user);
    console.log(this.store.cardNumber);
    // this.confirmFn();
    // this.WorkersUsersID = storage.getWorkersUsers().WID;
    // this.WorkersName = storage.getWorkersUsers().WName;
    // console.log(this.WorkersName, this.WorkersUsersID);
    this.getList();
    // this.operation = {}
    // this.tableData = []
  },
  computed: {
    finishNumber() {
      if (!this.operation.WARPPLANNO || this.tableData.length === 0) return;
      let finishNumber = 0;
      this.tableData.forEach((item) => {
        finishNumber += item.InputNumber - 0;
      });
      // finishNumber = this.operation.FINISHQUANTITY
      return parseInt(finishNumber);
    },
    userName() {
      return this.user.UserId + "," + this.user.PersonName;
    },
  },
  methods: {
    handleClose() {
      this.isAGVCode = false;
    },
    // 根据条件查找指定的织造信息列表
    confirmFn1() {
      let params = {
        Page: this.listPage.Page,
        PageSize: this.listPage.PageSize,
        Entity: {
          UserID: this.user.UserId,
          EquipmentID: this.user.MachineId,
          // STATEID: this.stores.status,
          BillID: this.store.cardNumber.trim(),
        },
      };
      console.log(params);
      api.GetZZInfoList(this.$qs.stringify(params)).then((res) => {
        console.log(res.data);
        if (res.data.Entities.length > 0) {
          this.operation = res.data.Entities[0];
          console.log(this.operation);
        }
        if (res.data.Success !== false && this.store.cardNumber !== "") {
          // if (this.store.cardNumber !== "") {

          this.operation.COMPLETEROLLNUM = res.data.Entities[0].COMPLETEROLLNUM;
          this.operation.UnFINISHQUANTITY =
            res.data.Entities[0].UnFINISHQUANTITY;
          this.operation.UnCOMPLETEROLLNUM =
            res.data.Entities[0].UnCOMPLETEROLLNUM;
          // }
          this.list = res.data.Entities;
          this.total = res.data.Total;
          // if (this.list.length === 1) {
          //   this.user.MachineId = res.data.Entities[0].WEAVDEVICEID;
          // }

          this.ISZZWorkSB();
          this.getList();
          this.GetWeavCheckList();
        } else if (this.store.cardNumber === "") {
          this.list = [];
        } else {
          this.list = [];
          return this.$message({
            showClose: true,
            message: res.data.Message,
            type: "error",
          });
        }
      });
    },
    confirmFn() {
      let params = {
        Page: this.listPage.Page,
        PageSize: this.listPage.PageSize,
        Entity: {
          UserID: this.user.UserId,
          EquipmentID: this.user.MachineId,
          // STATEID: this.stores.status,
          BillID: this.store.cardNumber.trim(),
        },
      };
      console.log(params);
      api.GetZZInfoList(this.$qs.stringify(params)).then((res) => {
        console.log(res.data);
        if (res.data.Success !== false && this.store.cardNumber !== "") {
          // if (this.store.cardNumber !== "") {
          this.operation.COMPLETEROLLNUM = res.data.Entities[0].COMPLETEROLLNUM;
          this.operation.UnFINISHQUANTITY =
            res.data.Entities[0].UnFINISHQUANTITY;
          this.operation.UnCOMPLETEROLLNUM =
            res.data.Entities[0].UnCOMPLETEROLLNUM;
          // }
          this.list = res.data.Entities;
          this.total = res.data.Total;
          // if (this.list.length === 1) {
          //   this.user.MachineId = res.data.Entities[0].WEAVDEVICEID;
          // }
          // this.dialogVisible2 = true;
          // this.ISZZWorkSB();
        } else if (this.store.cardNumber === "") {
          this.list = [];
        } else {
          this.list = [];
          return this.$message({
            showClose: true,
            message: res.data.Message,
            type: "error",
          });
        }
      });
    },
    sure() {
      this.dialogVisible2 = false;
    },
    goOut() {
      this.dialogVisible2 = false;
      this.store.cardNumber = "";
      this.list = [];
    },
    // 验证任务书设备
    ISZZWorkSB() {
      let params = {
        WEAVNO: this.store.cardNumber.trim(),
        EQUIPMENTID: this.user.MachineId,
      };
      console.log(params);
      api.ISZZWorkSB(this.$qs.stringify(params)).then((res) => {
        console.log(res.data);
        this.mes3 = "";
        if (res.data.Success !== false) {
          this.dialogVisible2 = true;
          this.mes3 = res.data.Message;
        } else {
          this.dialogVisible2 = false;
        }
      });
    },
    // 扫任务书号
    getSaoma() {
      // console.log(1);
      this.showvideo = true;
      this.openScan();
      // console.log(2);
    },
    // 获取近3天指定报工人的织造报工明细内容 （新）
    getList() {
      let params = {
        Page: this.listPage.Page,
        PageSize: this.listPage.PageSize,
        Entity: {
          BillID: this.operation.WEAVNO,
        },
      };
      console.log(params);
      // console.log(params);
      api.GetZZWorkInfoListByTaskNO(this.$qs.stringify(params)).then((res) => {
        console.log(res.data);
        this.tableData = res.data.Entities || [];
        this.total = res.data.Total;
        if (this.tableData.length) {
          this.tableData.forEach((item) => {
            this.$set(item, "isEdit", false);
          });
        }
        this.confirmFn();
      });
    },
    GetWeavCheckList() {
      api.GetWeavCheckList(this.operation.WEAVNO).then((res) => {
        console.log(res.data);
        if (res.data.length > 0) {
          this.cheackList = res.data[0];
          this.cheackLists = res.data;
          this.Total = res.data.length;
        } else {
          this.cheackList = [];
          this.cheackLists = [];
          // return this.$message({
          //   message: res.data.Message,
          //   type: "error",
          // });
        }
      });
    },
    //织造工单更新
    handleEdit(row) {
      row.isEdit = !row.isEdit;
    },
    handleEditOk(index, row) {
      let params = {
        ORGID: "",
        BILLNO: this.tableData[index].BILLNO, //主键单据号
        WEAVNO: this.tableData[index].WEAVNO,
        BILLDATE: this.tableData[index].BILLDATE,
        SERIALNO: this.tableData[index].SERIALNO,
        SUBBATCHNO: this.tableData[index].SUBBATCHNO,
        InputNumber: this.tableData[index].InputNumber,
        MachineNumber: this.tableData[index].MachineNumber,
        WorkersUsersID: this.tableData[index].WorkersUsersID,
        WorkersName: this.tableData[index].WorkersName,
        EQUIPMENTID: this.tableData[index].EQUIPMENTID,
        CreatorId: this.tableData[index].CreatorId,
        LastUpdateId: this.tableData[index].LastUpdateId,
      };
      console.log(params);
      api.ZZWorkSubmitUpdate(this.$qs.stringify(params)).then((res) => {
        console.log(res.data);
        if (res.data.Success) {
          row.isEdit = false;
          this.getList();

          return this.$message({
            showClose: true,
            message: "操作成功",
            type: "success",
          });
        } else if (res.data.Message.includes("更新到后整理任务失败")) {
          return this.$message({
            showClose: true,
            message: res.data.Message,
            type: "success",
            duration: 50000,
          });
        } else {
          return this.$message({
            showClose: true,
            message: res.data.Message,
            type: "error",
            // duration: 0
          });
        }
      });
    },
    // 呼叫帮叫工
    callHelp() {
      if (!this.operation.hasOwnProperty("WARPPLANNO")) {
        return this.$message.error("请选择一条数据");
      }
      let params = {
        Code: this.operation.WEAVNO,
        PersonId: this.user.PersonId,
        PersonName: this.user.PersonName,
        RESERVEDNO1: this.operation.PRODUCTID,
        RESERVEDNO2: this.operation.WEAVDEVICEID,
      };
      console.log(params);
      this.loading = true;
      api.CallHelpWorker(this.$qs.stringify(params)).then((res) => {
        console.log(res.data);
        this.loading = false;
        if (res.data.Success) {
          return this.$message({
            showClose: true,
            message: "操作成功",
            type: "success",
          });
        } else {
          return this.$message({
            showClose: true,
            message: res.data.Message,
            type: "error",
            // duration: 0
          });
        }
      });
    },
    // 呼叫接头
    callJoint() {
      if (!this.operation.hasOwnProperty("WARPPLANNO")) {
        return this.$message.error("请选择一条数据");
      }
      let params = {
        Code: this.operation.WEAVNO,
        PersonId: this.user.PersonId,
        PersonName: this.user.PersonName,
        RESERVEDNO1: this.operation.PRODUCTID,
        RESERVEDNO2: this.operation.WEAVDEVICEID,
      };
      console.log(params);
      this.loading = true;
      api.CallAcceptWorker(this.$qs.stringify(params)).then((res) => {
        console.log(res.data);
        this.loading = false;
        if (res.data.Success) {
          return this.$message({
            showClose: true,
            message: "操作成功",
            type: "success",
          });
        } else {
          return this.$message({
            showClose: true,
            message: res.data.Message,
            type: "error",
            // duration: 0
          });
        }
      });
    },
    // 呼叫对样
    handleFnderClick() {
      if (!this.operation.hasOwnProperty("WARPPLANNO")) {
        return this.$message.error("请选择一条数据");
      }
      const params = {
        Code: this.operation.WEAVNO,
      };
      api.GetMATERIALBATCHNOs(this.$qs.stringify(params)).then((res) => {
        this.operationModel = res.data;
        console.log(this.operationModel);
        this.isSample = true;
      });
    },
    SampleCodeBlur() {
      this.loading = true;
      this.operationModel.WorkersUsersID = storage.getWorkersUsers().WID;
      this.operationModel.WorkersName = storage.getWorkersUsers().WName;
      api.ZZCheckSample(this.$qs.stringify(this.operationModel)).then((res) => {
        console.log(res.data);
        this.loading = false;
        if (res.data.Success) {
          this.isSample = false;
          // this.store.cardNumber = "";
          this.confirmFn();
          this.getList();
          this.GetWeavCheckList();
          return this.$message({
            showClose: true,
            message: "操作成功",
            type: "success",
          });
        } else {
          return this.$message({
            showClose: true,
            message: res.data.Message,
            type: "error",
            // duration: 0
          });
        }
      });
    },
    // 接头报工
    JTWorkEND() {
      // 如果this.operation有id证明选中单选框在执行其他操作
      // if (!this.operation.hasOwnProperty("WEAVNO")) {
      //   return this.$message.error("请选择一条数据");
      // }
      this.$router.push({
        path: "/zhizao/JTfiberOk",
        query: {
          pObjs: JSON.stringify(this.operation),
        },
      });
    },
    ISZZWorkEND() {
      api.ISZZWorkEND(this.operation.WEAVNO).then((res) => {
        if (res.data.Success !== false) {
          this.dialogVisible1 = true;
          this.mes1 = res.data.Message;
        } else {
          // 任务结束
          this.ZZToEnd();
        }
      });
    },
    conmitOk() {
      this.ZZToEnd();
    },
    cancel() {
      this.dialogVisible1 = false;
    },
    ZZToEnd() {
      const params = {
        BillID: this.operation.WEAVNO,
      };
      console.log(params);
      this.loading = true;
      api.ZZToEnd(this.$qs.stringify(params)).then((res) => {
        console.log(res);
        this.loading = false;
        if (res.data.Success) {
          this.store.cardNumber = "";
          this.confirmFn();
          this.getList();
          this.GetWeavCheckList();
          this.dialogVisible1 = false;
          return this.$message({
            showClose: true,
            message: "操作成功",
            type: "success",
          });
        } else {
          return this.$message({
            showClose: true,
            message: res.data.Message,
            type: "error",
          });
        }
      });
    },
    // 任务结束
    // endbackOk() {
    //   if (!this.operation.BILLNO) {
    //     return Notify({ type: "danger", message: "选择任务书号" });
    //   }
    //   this.$confirm("确定是否结束任务书?", "提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     cancelButtonClass: "btn-cancel",
    //     type: "warning",
    //   })
    //     .then(() => {
    //       const params = {
    //         BillID: this.operation.WEAVNO,
    //       };
    //       console.log(params);
    //       this.loading = true;
    //       api.ZZToEnd(this.$qs.stringify(params)).then((res) => {
    //         console.log(res);
    //         this.loading = false;
    //         if (res.data.Success) {
    //           this.store.cardNumber = "";
    //           this.confirmFn();
    //           return this.$message({
    //             showClose: true,
    //             message: "操作成功",
    //             type: "success",
    //           });
    //         } else {
    //           return this.$message({
    //             showClose: true,
    //             message: res.data.Message,
    //             type: "error",
    //             // duration: 0
    //           });
    //         }
    //       });
    //     })
    //     .catch(() => {
    //       this.$message({
    //         type: "info",
    //         message: "已取消结束任务书",
    //       });
    //     });
    // },
    // 呼叫AGV
    async callAGV() {
      const params = {
        Code: this.store.cardNumber.trim(),
        RESERVEDNO1: this.user.MachineId || this.user.WARPDEVICEID,
        PersonId: this.user.PersonId,
        PersonName: this.user.PersonName,
      };
      const callAGV = await api.ZZShoutAGV(this.$qs.stringify(params));
      console.log(callAGV.data);
      const data = {
        machineID: callAGV.data.MachineID, //机台编号
        processId: callAGV.data.ProcessId, //工序
        productId: callAGV.data.ProductId, //产品ID
        productName: callAGV.data.ProductName, //产品名称
        productAttributes: callAGV.data.ProductAttributes, //产品规格属性
        productNumber: callAGV.data.ProductNumber, //产品数量
      };
      const res = await api.CallMes(data);
      if (res.data.Success) {
        return this.$message({
          showClose: true,
          message: "操作成功",
          type: "success",
        });
      } else {
        return this.$message({
          showClose: true,
          message: res.data.Message,
          type: "error",
          // duration: 0
        });
      }
    },
    // 落布完成
    async AGVCodeBlur() {
      const AGVInfo = await api.AGVGetInfoByCode(this.store.AGVCode);
      const data = {
        machineID: AGVInfo.data.MachineID,
        processId: AGVInfo.data.ProcessId,
        productId: AGVInfo.data.ProductId,
        productName: AGVInfo.data.ProductName,
        productAttributes: AGVInfo.data.ProductAttributes,
        productNumber: AGVInfo.data.ProductNumber,
      };
      const res = await api.mesMachineok(data);
      if (res.data.Success) {
        this.isAGVCode = false;
        return this.$message({
          showClose: true,
          message: "操作成功",
          type: "success",
        });
      } else {
        return this.$message({
          showClose: true,
          message: res.data.Message,
          type: "error",
          // duration: 0
        });
      }
    },
    more() {
      this.ischeack = true;
      this.GetWeavCheckList();
    },
    // 选中
    selectItem(item, index) {
      console.log(item);
      this.operation = item;
      this.currentIndex = index;
      this.getList();
      this.GetWeavCheckList();
    },
    // // 选中
    // selectItem1(item, index) {
    //   console.log(item);
    //   this.currentIndex1 = index;
    //   // this.getList()
    // },
    // 设置index
    getTabIndex({ row, rowIndex }) {
      row.index = rowIndex;
    },

    open() {
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    GetKeyVal(val) {
      console.log(val);
      this.store.cardNumber = val;
    },
    // 呼叫班组长
    hujiaoOk() {
      this.$confirm("确定是否呼叫班组长?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "btn-cancel",
        type: "warning",
      })
        .then(() => {
          const params = {
            RESERVEDNO2: this.user.MachineId || this.operation.WARPDEVICEID,
            PersonId: this.user.PersonId,
            PersonName: this.user.PersonName,
          };
          this.loading = true;
          api.CallGroupLeader(this.$qs.stringify(params)).then((res) => {
            console.log(res);
            this.loading = false;
            if (res.data.Success) {
              this.getList();
              return this.$message({
                showClose: true,
                message: "操作成功",
                type: "success",
              });
            } else {
              return this.$message({
                showClose: true,
                message: res.data.Message,
                type: "error",
                // duration: 0
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消呼叫班组长",
          });
        });
    },
    // 报工
    tofiberOk() {
      // 如果this.operation有id证明选中单选框在执行其他操作
      // if (!this.operation.hasOwnProperty("WEAVNO")) {
      //   return this.$message.error("请选择一条数据");
      // }
      this.$router.push({
        path: "/zhizao/fiberOk",
        query: {
          pObjs: JSON.stringify(this.operation),
        },
      });
    },
    // 打样报工
    toDyfiberOk() {
      // 如果this.operation有id证明选中单选框在执行其他操作
      // if (!this.operation.hasOwnProperty("WEAVNO")) {
      //   return this.$message.error("请选择一条数据");
      // }
      this.$router.push({
        path: "/zhizao/DyfiberOk",
        query: {
          pObjs: JSON.stringify(this.operation),
        },
      });
    },
    // 扫码获取任务书
    getAGVCode() {
      //   this.orCodeType = "DC";
      //   this.locationLayer = true;
      //   this.orCodeStaticVal = 2;
      //   this.orCodeValStatic = true;
    },
    torenwushu() {
      // 如果this.operation有id证明选中单选框在执行其他操作
      if (!this.operation.hasOwnProperty("WEAVNO")) {
        return this.$message.error("请选择一条数据");
      }
      this.$router.push({
        path: "/zhizao/renwushu",
        query: {
          pObjs: JSON.stringify(this.operation),
        },
      });
    },
    toBaobiao() {
      this.$router.push({
        path: "/zhizao/SCbaobiao",
      });
    },

    // 扫码功能
    // 打开扫码
    openScan() {
      this.codeReader = new BrowserMultiFormatReader();
      console.log(this.codeReader);
      this.codeReader
        .getVideoInputDevices()
        .then(async (videoInputDevices) => {
          this.tipShow = true;
          this.tipMsg = "正在尝试识别....";
          this.videoInputDevicesArray = videoInputDevices;
          //
          console.log("获取到的摄像头", this.videoInputDevicesArray);
          if (this.videoInputDevicesArray.length > 1) {
            this.deviceId = this.videoInputDevicesArray[1].deviceId;
            console.log(this.deviceId);
          } else {
            this.deviceId = this.videoInputDevicesArray[0].deviceId;
            console.log(this.deviceId);
          }
          this.decodeFromInputVideoFunc();
        })
        .catch(() => {
          this.tipShow = false;
        });
    },
    // 开始解码
    decodeFromInputVideoFunc() {
      if (this.videoInputDevicesArray.length == 0) {
        this.textContent = "初始化摄像头失败";
        document.getElementById("video").style.display = "none";
        return;
      }
      this.codeReader.reset();
      this.codeReader.decodeFromInputVideoDeviceContinuously(
        this.deviceId,
        "video",
        (result) => {
          this.tipMsg = "正在扫描";
          if (result) {
            if (result.text) {
              console.log("扫描成功", result.text);
              this.store.cardNumber = result.text;
              this.confirmFn();
              this.tipMsg = "扫描成功";
              this.showvideo = false;
              this.tipShow = true;
              window && window.getResultEvent(result);
              // window?.parent?.Gikam?.toast("扫码成功");
              // 关闭扫码功能
              this.codeReader.reset();
              this.codeReader.stopContinuousDecode();
            }
          }
        }
      );
    },
    cutover() {
      if (
        this.videoInputDevicesArray &&
        this.videoInputDevicesArray.length > 1
      ) {
        if (this.deviceId === this.videoInputDevicesArray[0].deviceId) {
          return (this.deviceId = this.videoInputDevicesArray[1].deviceId);
        } else {
          return (this.deviceId = this.videoInputDevicesArray[0].deviceId);
        }
      }
      this.codeReader.stopStreams();
      return;
    },
    // 切换摄像头
    async toggle() {
      this.codeReader.stopStreams();
      this.timer = setTimeout(() => {
        this.timer = null;
      }, 2000);
      if (this.timer) {
        await this.codeReader.tryPlayVideo("video");
        this.cutover();
        this.decodeFromInputVideoFunc();
      }
    },
    colose() {
      this.showvideo = false;
    },
  },
};
</script>
<style>
.el-table--border::after,
.el-table--group::after,
.el-table::before {
  background-color: #fff;
}

.el-table {
  color: #737373;
  font-size: 8px;
  padding: 0;
  border: 1px solid #eee;
}

.el-table .cell {
  text-align: center;
  padding: 0;
}

.el-table th>.cell {
  padding: 0;
}

.el-table .cell,
.el-table--border td:first-child .cell,
.el-table--border th:first-child .cell {
  padding-left: 0;
}

.el-table thead {
  color: #3c76ec;
  font-weight: 100;
  font-size: 8px;
  background: #f8f8f8;
}

.el-table td,
.el-table th.is-leaf {
  border-bottom: 1px solid #eee;
  border-right: 1px solid #eee;
  padding: 0;
}

.el-icon-close-notification {
  font-size: 14px;
  color: #fff;
}

.el-icon-refresh-right {
  font-size: 14px;
  color: #fff;
}

.el-icon-user {
  font-size: 14px;
  color: #fff;
}

.el-select-dropdown__empty {
  font-size: 8px !important;
}

.el-select-dropdown__item {
  font-size: 8px;
  height: 0.6rem;
  line-height: 0.6rem;
}

.md-number-keyboard-container .keyboard-operate .keyboard-operate-list .keyboard-operate-item.delete {
  height: 1rem;
}

.keyboard-number-item {
  font-size: 10px !important;
}

.el-dialog {
  background-color: #fff !important;
}

.el-dialog__header {
  padding: 0.2rem 0.3rem;
}

.el-dialog--center .el-dialog__body {
  padding: 0.2rem !important;
  font-size: 0.25rem !important;
}

.el-input--mini .el-input__inner {
  font-size: 0.23rem !important;
  height: 0.6rem;
  line-height: 0.6rem;
}

.el-button {
  font-size: 12px;
  color: #fff !important;
}

.el-button--primary.is-plain {
  color: #409eff !important;
}

.el-dialog--center .el-dialog__footer .el-button--mini,
.el-button--mini.is-round {
  padding: 0.15rem 0.3rem;
  font-size: 0.28rem;
}

.van-popover__action {
  width: 2rem;
  height: 0.8rem;
  padding: 0;
  font-size: 0.3rem;
  line-height: 0.8rem;
  background: #fff;
  border-color: #409eff;
  /* color: #409EFF !important */
}

.el-message-box__title {
  font-size: 0.4rem;
}

.el-message-box__message p {
  font-size: 0.3rem;
}

.el-message-box__btns .el-button {
  font-size: 0.3rem;
}

.el-button--small,
.el-button--small.is-round {
  padding: 0.15rem 0.3rem;
}

.van-popover__action-text {
  background: #fff;
  border-color: #409eff;
  color: #409eff !important;
}

.el-checkbox__inner {
  width: 0.28rem;
  height: 0.28rem;
}

.el-dialog__title {
  font-size: 14px !important;
  text-align: center;
}

.btn-cancel {
  background-color: #f34b53 !important;
  border-color: #f34b53;
}

.van-empty {
  padding: 0;
}
</style>
<style lang="less" scoped>
@deep: ~">>>";

.box {
  padding: 8px;
  box-sizing: border-box;
  height: 100%;
  overflow: hidden;
  background: #eee;
  display: flex;
  flex-flow: column;
  justify-content: space-between;

  @{deep} .el-dialog__footer {
    width: 40%;
    display: flex;
    justify-content: center;
    margin: 0 auto !important;
  }

  h1 {
    // padding-left: 5px;
    font-size: 9px;
    height: 0.6rem;
    height: 0.6rem;
    line-height: 0.6rem;
    font-weight: bold;
    color: #131313;
  }

  .max {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    .btn {
      height: 5%;
      background: #fff;
      padding: 6px 8px;
      display: flex;
      justify-content: space-between;
      // border: 1px solid #cecece;

      .el-button {
        color: #fff;
        padding: 0.15rem;
        font-size: 10px;
        border: 0;
        // margin-right: 0.8rem;
      }

      @{deep}.el-button--mini,
      .el-button--mini.is-round {
        width: 1.6rem;
        padding: 0.15rem 0;
      }
    }

    .bottom {
      height: 90%;
      display: flex;
      justify-content: space-between;

      .left {
        // flex: 1;
        width: 29%;
        height: 100%;
        color: #323232;
        display: flex;
        flex-flow: column;
        justify-content: flex-start;

        .top {
          margin-top: 5px;
          padding: 0 5px 5px 5px;
          // height: 21%;
          //  height: 24%;
          background: #fff;
          // margin-bottom: 10px;
          display: flex;
          flex-flow: column;
          // border: 1px solid #cecece;

          // h1 {
          //  border-bottom:2px solid #eee;
          // }

          .saoma {
            // border:1px solid #eee;
            display: flex;
            align-items: center;
            justify-content: flex-start;

            // height:1.2rem;
            // line-height:1.2rem;
            p {
              width: 23%;
              font-size: 8px;
              //  color: #737373;
              // font-weight:600;
              line-height: 1rem;
              // color:#3c76ec;
            }

            @{deep} .el-input {
              width: 70%;
              margin-left: 5px;

              .el-input__inner {
                // width: 100%;
                height: 0.5rem;
                line-height: 0.5rem;
                font-size: 0.2rem;
                // border: 0;
                border: 1px solid #bfbfbf;
                border-radius: 0;
              }

              .el-input-group__append {
                // right: 0.4rem;
                border: 0;
                width: 0.5rem;
                height: 0.02rem !important;
                padding: 0;

                img {
                  width: 0.5rem;
                  height: 0.5rem !important;
                  line-height: 0.2rem !important;
                  // background: #3c76ec;
                }
              }
            }
          }
        }




        .img {
          height: 3.2rem;
          margin-top: 8px;
          background-color: #fff;
          // margin-top: 10px;
          padding: 5px;
          text-align: center;
          box-sizing: border-box;

          img {

            width: 100%;
            height: 100%;

          }
        }

        .title {
          padding-left: 8px;
          color: #323232 !important;
        }

        .content {
          height: 4rem;
          margin-top: 0;
          // background-color: #f00;

          .text {
            width: 100%;
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;

            p {
              display: flex;
              justify-content: flex-start;
              flex-wrap: wrap;
              width: 100%;
              line-height: 0.4rem;
              // flex-wrap: nowrap;
              font-size: 6px !important;
            }
          }
        }

        .bottom,
        .content {
          // height: 10rem;
          overflow-y: auto;
          padding: 10px 5px;
          background: #fff;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;

          .list {
            padding: 0.1rem;
            // margin-bottom: 6px;
            border: 1px solid #eee;
            align-items: center;
            font-size: 8px;
            display: flex;
            // justify-content: flex-start;
            justify-content: space-between !important;
            // flex-wrap: wrap;

            .text {
              width: 100%;

              p {
                line-height: 0.4rem;

                span {
                  font-size: 8px;
                  // color: #505050;
                }
              }
            }

            @{deep}.el-button {
              color: #fff;
              padding: 0.2rem;
              width: 1.8rem;
              height: 0.6rem;
              margin-top: 8px;
              font-size: 9px;
              border: 0;
            }

            .btns {
              @{deep}.el-button {
                color: #fff;
                padding: 0.2rem;
                width: 1.8rem;
                height: 0.6rem;
                margin-top: 8px;
                font-size: 9px;
                border: 0;
              }
            }
          }

          .empty {
            width: 100%;
            height: 100%;

            .van-empty {
              height: 100%;

              @{deep}.van-empty__image {
                width: 100% !important;
              }

              @{deep} .van-empty__description {
                margin-top: 0 !important;
              }
            }
          }

          .active {
            background-color: #eee !important;
            // color: #fff !important;
          }
        }

        .bottom {
          height: 2.6rem;
          // line-height: 2rem;
          margin-top: 8px;
          overflow: hidden;

          .list {
            height: 100%;
            padding: 0.1rem;
            // margin-bottom: 6px;
            border: 1px solid #eee;
            align-items: center;
            font-size: 8px;
            display: flex;
            // background-color: #f34b53;
            // justify-content: flex-start;
            justify-content: space-between !important;
            // flex-wrap: wrap;
          }

          // background-color: #f00;

        }

      }

      .right {
        // flex:1;
        width: 70%;
        height: 100%;
        display: flex;
        flex-flow: column;
        justify-content: flex-start;
        // background-color: #f00;

        .top {
          // height: 21%;
          // overflow-y:auto;
          margin-top: 5px;
          padding: 2.5px 8px;
          background: #fff;
          // border: 1px solid #cecece;

          .row {
            padding: 0 5px;
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            line-height: 0.45rem;

            @{deep}.el-col {
              font-size: 0.21333rem;
            }
          }
        }

        .bottom {
          padding: 10px 10px 0;
          margin-top: 10px;
          // border: 1px solid #cecece;
          background: #fff;

          .tab {
            width: 100%;
            height: 100%;

            @{deep}.el-button--mini {
              font-size: 8px;
              color: #f34b53 !important;
            }
          }
        }
      }
    }

  }

  .code-input {
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    align-items: center;

    span {
      width: 20%;
    }
  }

  .InputNumber {
    .el-input {
      // width: 100%;
      height: 0.5rem;
      line-height: 0.5rem;
      font-size: 0.2rem;

      @{deep} .el-input__inner {
        width: 80%;
        height: 0.5rem;
        font-size: 0.0521rem;
      }
    }
  }
}

.code-reader-content {
  .page {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;

    #video {
      height: 100%;
      width: 100%;
      object-fit: fill;
    }
  }

  .scan-box {
    position: absolute;
    left: 50%;
    top: 60%;
    transform: translate(-50%, -90%);
    height: 30%;
    width: 70%;

    .frame {
      position: absolute;
      width: 15px;
      height: 15px;
      border: 3px solid transparent;
    }

    .upper-left {
      top: 0;
      left: 0;
      border-left-color: rgba(66, 133, 244, 1);
      border-top-color: rgba(66, 133, 244, 1);
    }

    .upper-right {
      top: 0;
      right: 0;
      border-right-color: rgba(66, 133, 244, 1);
      border-top-color: rgba(66, 133, 244, 1);
    }

    .lower-right {
      bottom: 0;
      right: 0;
      border-bottom-color: rgba(66, 133, 244, 1);
      border-right-color: rgba(66, 133, 244, 1);
    }

    .lower-left {
      bottom: 0;
      left: 0;
      border-left-color: rgba(66, 133, 244, 1);
      border-bottom-color: rgba(66, 133, 244, 1);
    }

    .pointer-box {
      position: absolute;
      top: 0;
      left: 0;
      width: 98%;
      height: 100%;
      overflow: hidden;

      .pointer {
        height: 3px;
        background-image: linear-gradient(to right,
            transparent 0%,
            #afa 50%,
            transparent 100%);
        transform: translateY(-3px);
        animation: move 2s linear infinite;
      }

      @keyframes move {
        0% {
          transform: translateY(-3px);
        }

        100% {
          transform: translateY(calc(20vh - 3px));
        }
      }
    }

    .tip {
      position: absolute;
      left: 50%;
      top: 120%;
      transform: translate(-50%, 0);
      white-space: nowrap;
      // color: rgb(85, 209, 28);
      color: red;
      font-size: 16px;
    }

    .btn-switch {
      position: absolute;
      left: 50%;
      top: 140%;
      width: 50px;
      height: 20px;
      transform: translate(-50%, 0);
      background-color: #aaf;
      color: #fff;
      text-align: center;
      line-height: 20px;
      font-size: 12px;
      // background: url('../../../img/icon/switch.svg') no-repeat center;
    }
  }
}

.el-dialog__body {
  .list {
    .text {
      width: 100%;
      display: flex;
      justify-content: space-around !important;

      p {
        width: 60%;
        line-height: 0.6rem;

        span {
          font-size: 8px;
        }
      }
    }
  }
}

@{deep} .el-dialog__headerbtn {
  top: 0.1rem;
}

@{deep}.el-dialog__footer {
  width: 80% !important;
  display: flex !important;
  justify-content: center !important;
}
</style>
